module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/OutlineoftheBook.htm"
    }
  }, [_vm._v("Outline of the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface.htm"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartI.htm"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part I: The Bible and Mission")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote2"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch01.htm"
    }
  }, [_vm._v(" 1 Searching for a Missional Hermeneutic")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch02.htm"
    }
  }, [_vm._v(" 2 Shaping a Missional Hermeneutic")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartII.htm"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part II: The God of Mission")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote2"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch03.htm"
    }
  }, [_vm._v(" 3 The Living God Makes Himself Known in Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch04.htm"
    }
  }, [_vm._v(" 4 The Living God Makes Himself Known in Jesus Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch05.htm"
    }
  }, [_vm._v(" 5 The Living God Confronts Idolatry")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartIII.htm"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part III: The People of Mission")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote2"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch06.htm"
    }
  }, [_vm._v(" 6 God’s Elect People")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch07.htm"
    }
  }, [_vm._v(" 7 God’s Particular People")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch08.htm"
    }
  }, [_vm._v(" 8 God’s Model of Redemption")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch09.htm"
    }
  }, [_vm._v(" 9 God’s Model of Restoration")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch10.htm"
    }
  }, [_vm._v("10 The Span of God’s Missional Covenant")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch11.htm"
    }
  }, [_vm._v("11 The Life of God’s Missional People")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartIV.htm"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part IV: The Arena of Mission")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote2"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch12.htm"
    }
  }, [_vm._v("12 Mission and God’s Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch13.htm"
    }
  }, [_vm._v("13 Mission and God’s Image")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch14.htm"
    }
  }, [_vm._v("14 God and the Nations in Old Testament Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Ch15.htm"
    }
  }, [_vm._v("15 God and the Nations in New Testament Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Epilogue.htm"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Bibliography.htm"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/nameindex.htm"
    }
  }, [_vm._v("Name Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/subjectindex.htm"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/scriptureindex.htm"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Langhampage.htm"
    }
  }, [_vm._v("Langham Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praisefor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('em', [_vm._v("The Mission of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0